import * as React from 'react';

export const BinIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M10.7838 3.46149L10.2065 11.5443C10.1567 12.241 9.57699 12.7808 8.87852 12.7808H3.36979C2.67132 12.7808 2.0916 12.241 2.04184 11.5443L1.46449 3.46149M4.79282 6.12415V10.1181M7.45548 6.12415V10.1181M8.12115 3.46149V1.46449C8.12115 1.09686 7.82312 0.798828 7.45548 0.798828H4.79282C4.42519 0.798828 4.12716 1.09686 4.12716 1.46449V3.46149M0.798828 3.46149H11.4495"
			stroke="#808285"
			strokeWidth="1.5976"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
